import { ExecutionFlowModel } from "../../models/workFlow/ExecutionFlowModel";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchExecutionFlows = async (
  accessToken: string,
  tenantId: number
): Promise<ExecutionFlowModel[]> => {
  
  try {
    const endpoint = `${API_URL}/api/ExecutionFlow/GetAllExecutionFlow?tenantId=${tenantId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      throw new Error("Failed to fetch execution flows.");
    }

    const data = await response.json();
    console.log("Raw execution flow data:", data);

    const mappedExecutionFlows = mapToExecutionFlow(data);
    console.log("Mapped execution flow data:", mappedExecutionFlows);

    return mappedExecutionFlows;
  } catch (error) {
    console.error("Error in fetchExecutionFlows:", error);
    throw error;
  }
};

export const GetExecutionByConnectionId = async (
  accessToken: string,
  connectionId: number
): Promise<ExecutionFlowModel | null> => {
  
  try {
    const endpoint = `${API_URL}/api/ExecutionFlow/GetExecutionByConnectionId?connectionId=${connectionId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch execution flow.");
    }

    // const data = await response.json();
    // console.log("Raw execution flow data:", data);

    // const mappedExecutionFlows = mapToExecutionFlow(data);
    // console.log("mappedExecutionFlows  execution flow data:", mappedExecutionFlows[0] );

    // // Return the first item since we're getting by ID
    // return mappedExecutionFlows.length > 0 ? mappedExecutionFlows[0] : null;

    const data = await response.json();
    console.log("Raw execution flow data:", data);

    // Directly return mapped object
    const mappedExecutionFlow: ExecutionFlowModel = {
      executionFlowId: data.executionFlowId,
      connectionId: data.connectionId,
      name: data.name,
      description: data.description,
      workflowJson: data.workflowJson,
      executionType: data.executionType,
      createdAt: data.createdAt,
      createdBy: data.createdBy,
      updatedAt: data.updatedAt,
      updatedBy: data.updatedBy,
      isDeleted: data.isDeleted,
      deletedAt: data.deletedAt,
      deletedBy: data.deletedBy,
    };
    console.log(
      "mappedExecutionFlows  execution flow data:",
      mappedExecutionFlow
    );
    return mappedExecutionFlow;
  } catch (error) {
    console.error("Error in fetchExecutionFlowById:", error);
    throw error;
  }
};

export const mapToExecutionFlow = (data: any[]): ExecutionFlowModel[] => {
  return data.map((item: any) => ({
    executionFlowId: item.executionFlowId,
    connectionId: item.connectionId,
    name: item.name,
    description: item.description,
    workflowJson: item.workflowJson,
    executionType: item.executionType,

    // Audit
    createdAt: item.createdAt,
    createdBy: item.createdBy,
    updatedAt: item.updatedAt,
    updatedBy: item.updatedBy,
    isDeleted: item.isDeleted,
    deletedAt: item.deletedAt,
    deletedBy: item.deletedBy,
  }));
};

export const createExecutionFlow = async (
  accessToken: string,
  executionFlowData: ExecutionFlowModel
): Promise<{
  success: boolean;
  data?: ExecutionFlowModel;
  message?: string;
  executionFlowId?: number;
}> => {
  try {
    console.log(
      "JSON.stringify(executionFlowData) ",
      JSON.stringify(executionFlowData)
    );

    const response = await fetch(
      `${API_URL}/api/ExecutionFlow/CreateExecutionFlow`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(executionFlowData),
      }
    );

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        data: result.data,
        message: result.message || "ExecutionFlow created successfully",
        executionFlowId: result.executionFlowId,
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to create execution flow",
      };
    }
  } catch (error) {
    console.error("Error creating execution flow:", error);
    return {
      success: false,
      message: "An error occurred while creating the execution flow",
    };
  }
};

export const updateExecutionFlow = async (
  accessToken: string,
  executionFlowData: ExecutionFlowModel
): Promise<{
  success: boolean;
  data?: ExecutionFlowModel;
  message?: string;
}> => {
  try {
    const response = await fetch(
      `${API_URL}/api/ExecutionFlow/UpdateExecutionFlow`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(executionFlowData),
      }
    );

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        data: result.data,
        message: result.message || "ExecutionFlow updated successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to update execution flow",
      };
    }
  } catch (error) {
    console.error("Error updating execution flow:", error);
    return {
      success: false,
      message: "An error occurred while updating the execution flow",
    };
  }
};

export const deleteExecutionFlow = async (
  accessToken: string,
  executionFlowId: number,
  deletedBy: number,
  tenantId: number
): Promise<{ success: boolean; message?: string }> => {
  try {
    const body = {
      executionFlowIds: [executionFlowId], // send as array
      deletedBy: deletedBy,
      tenantId: tenantId,
    };

    const response = await fetch(
      `${API_URL}/api/ExecutionFlow/DeleteExecutionFlow`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        message: result.message || "ExecutionFlow deleted successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to delete execution flow",
      };
    }
  } catch (error) {
    console.error("Error deleting execution flow:", error);
    return {
      success: false,
      message: "An error occurred while deleting the execution flow",
    };
  }
};

export const deleteMultipleExecutionFlows = async (
  accessToken: string,
  executionFlowIds: number[],
  deletedBy: number,
  tenantId: number
): Promise<{
  success: boolean;
  message?: string;
  deletedExecutionFlowIds?: number[];
}> => {
  try {
    const body = {
      executionFlowIds: executionFlowIds,
      deletedBy: deletedBy,
      tenantId: tenantId,
    };

    const response = await fetch(
      `${API_URL}/api/ExecutionFlow/DeleteExecutionFlow`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );

    const result = await response.json();

    if (response.ok) {
      return {
        success: true,
        message: result.message || "ExecutionFlows deleted successfully",
        deletedExecutionFlowIds: result.deletedExecutionFlowIds,
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to delete execution flows",
      };
    }
  } catch (error) {
    console.error("Error deleting execution flows:", error);
    return {
      success: false,
      message: "An error occurred while deleting the execution flows",
    };
  }
};
